import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'

export const fetchLedger = (studentID) => {
  const request = get(`/billings/${studentID}/ledger`)
  request.types = ['LED_REQ', 'LED_GET_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Ledger/actions.js